import { renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const columns = [
  {
    size: 180,
    accessorKey: "content",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    Cell: ({ cell, row }) => {
      return row.original.is_active ? (
        <b>{cell.getValue()}</b>
      ) : (
        cell.getValue()
      );
    },
    header: "Notifica",
  },
  {
    size: 180,
    accessorFn: (row) => (row.date ? row.date : ""),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Data",
  },
];

export default columns;
